import {
  Component,
  EventEmitter,
  Output,
  Input,
  OnChanges,
  OnInit,
} from "@angular/core";

const MAX_FILE_SIZE = 5 * 1024 * 1024;

export type UploadFile = {
  name: string;
  type: string;
  ext: string;
  size: number;
  blob: File;
  url: string;
  isImageType: boolean;
  isPdfType: boolean;
  isGenericType: boolean;
};

@Component({
  selector: "app-upload-single-file",
  templateUrl: "./upload-single-file.component.html",
  styleUrls: ["./upload-single-file.component.scss"],
})
export class UploadSingleFileComponent implements OnChanges, OnInit {
  @Input() readonly = false;
  @Input() preview = false;
  @Input() file: File | null = null;
  @Input() allowedExtensions = ["png", "jpeg", "jpg", "pdf"];
  @Output() selectFile = new EventEmitter<UploadFile | null>();

  showInvalidFileFormat = false;
  showFileSizeExceededError = false;
  showPreviewModal = false;

  fileSizeLimit = MAX_FILE_SIZE;

  uploadedFile: UploadFile | null = null;

  get getAllowedFormats() {
    return this.allowedExtensions?.reduce(
      (prev, curr) => prev + " | " + curr,
      ""
    );
  }

  ngOnInit(): void {
    1;
    // if (this.file) {
    //   this.getUploadFile(this.file).then((x) => (this.uploadedFile = x));
    // }
  }

  ngOnChanges(changes: any): void {
    if (changes["file"]) {
      const currentValue = changes["file"].currentValue;

      if (currentValue)
        this.getUploadFile(currentValue).then((x) => (this.uploadedFile = x));
      else this.uploadedFile = null;
    }
  }

  openPreviewModal() {
    if (!this.preview) return;

    this.showPreviewModal = true;
  }

  closePreviewModal() {
    if (!this.preview) return;

    this.showPreviewModal = false;
  }

  handleFileSelect(event: any): void {
    this.showInvalidFileFormat = false;
    this.showFileSizeExceededError = false;

    const file = event.target.files[0];

    if (this.isFileExtensionInvalid(file, this.allowedExtensions)) {
      this.showInvalidFileFormat = true;
      this.clearErrorsAfterDelay(); // Limpar mensagem após 10 segundos
    }

    if (this.isFileSizeInvalid(file, this.fileSizeLimit)) {
      this.showFileSizeExceededError = true;
      this.clearErrorsAfterDelay(); // Limpar mensagem após 10 segundos
    }

    this.readFile(file);

    event.target.value = "";
  }

  handleFileRemove(): void {
    this.selectFile.emit(null);
  }

  async getUploadFile(file: File): Promise<UploadFile> {
    const url = await this.convertToBase64(file);

    const isImage = file.type.startsWith("image/");
    const isPdf = file.type.includes("pdf");

    const uploadFile: UploadFile = {
      blob: file,
      name: file.name,
      type: file.type,
      ext:
        file.name.lastIndexOf(".") === -1
          ? null
          : file.name.substring(file.name.lastIndexOf(".") + 1),
      size: file.size,
      url: url,
      isImageType: isImage,
      isPdfType: isPdf,
      isGenericType: !isImage && !isPdf,
    };

    return uploadFile;
  }

  async readFile(file: File): Promise<void> {
    const uploadFile = await this.getUploadFile(file);
    this.selectFile.emit(uploadFile);
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  onModalKeyDown($event) {
    if ($event.key === "Escape" || $event.key === "Esc") {
      this.showPreviewModal = false;
    }
  }

  clearErrorsAfterDelay(): void {
    setTimeout(() => {
      this.showInvalidFileFormat = false;
      this.showFileSizeExceededError = false;
    }, 10000); // 10 segundos
  }

  private isFileExtensionInvalid = (file: File, allowedTypes: string[]) => {
    if (file) {
      const fileType = file.type.split("/")[1];
      return !allowedTypes.includes(fileType);
    }
    return false;
  };

  private isFileSizeInvalid = (file: File, maxSize: number) =>
    file.size > maxSize;
}
